import Styled, { css } from 'styled-components';

export const LabelStyles = css`
  font-size: ${({ theme: { label } }) => label.size};
  font-weight: ${({ theme: { label } }) => label.fontWeight};
  letter-spacing: ${({ theme: { label } }) => label.spacing};
  color: ${({ theme: { text }}) => text.colorText};
`;

export const Label = Styled.span`
  ${LabelStyles}
  text-transform: ${({ theme: { label } }) => label.textTransform};
`;

export const DatapointLabel = Styled.span`
  ${LabelStyles}
  display: block;
  letter-spacing: normal;
`;

export const CardLabel = Styled.span`
  ${LabelStyles}
  font-size: ${({ theme: { label }}) => label.cardLabelSize};
  line-height: 2.5em;
  display: block;
  letter-spacing: normal;
`;

export const FormLabel = Styled.label<{ disabled?: boolean }>`
  ${LabelStyles}
  display: block;
  color: ${({ theme: { label }}) => label.formLabelColor};
  font-weight: ${({ theme: { label }}) => label.formLabelWeight};
  margin-bottom: ${({ theme: { label }}) => label.formLabelMargin};
  letter-spacing: normal;

  ${({ theme: { label }, disabled }) => css`
    color: ${disabled && label.disabledColor && label.disabledColor};
    font-family: ${label.fontFamily && label.fontFamily};
  `}
`;

export const Legend = Styled.legend`
  ${LabelStyles}
`;

export const FormLegend = Styled.legend`
  ${LabelStyles}
  display: block;
  font-weight: ${({ theme: { label }}) => label.formLabelWeight};
  letter-spacing: normal;
  margin-bottom: ${({ theme: { label }}) => label.formLabelMargin};
`;

Label.displayName = 'Label';
Legend.displayName = 'Legend';
DatapointLabel.displayName = 'DatapointLabel';
CardLabel.displayName = 'CardLabel';
FormLabel.displayName = 'FormLabel';
FormLegend.displayName = 'FormLegend';
